var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgW(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 51,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.319.456c.671 0 1.224.192 1.656.576.431.384.648.912.648 1.584l-.145.936-15.911 46.08a1.84 1.84 0 01-.792 1.008c-.337.24-.72.36-1.152.36-1.104 0-1.825-.456-2.16-1.368L33.007 18.888 20.55 49.632c-.432.912-1.152 1.368-2.16 1.368-.432 0-.84-.12-1.224-.36a1.622 1.622 0 01-.649-1.008L.606 3.552a1.917 1.917 0 01-.216-.864c0-.672.24-1.2.72-1.584C1.638.672 2.19.456 2.766.456c.48 0 .912.12 1.296.36s.648.576.792 1.008l14.113 41.184L31.063 12.84c.431-.96 1.104-1.416 2.015-1.368.48-.048.889.072 1.224.36.385.24.672.576.864 1.008l12.025 30.168L61.157 1.824c.384-.912 1.105-1.368 2.16-1.368z",
    fill: "currentColor"
  })));
}
export default SvgW;